import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IPageState, EPageState } from '../../types/pageState/pageState';
import { ERequestStatus } from '../../types/requestStatus';

const initialState: IPageState = {
  state: EPageState.RequestForm,
  status: ERequestStatus.Initial,
  animationAvailable: true,
};

export const pageStateSlice = createSlice({
  name: 'pageState',
  initialState,
  reducers: {
    openRequestForm: state => {
      return {
        ...state,
        state: EPageState.RequestForm,
        status: ERequestStatus.Initial,
      };
    },
    setPhoneValidation: state => {
      return {
        ...state,
        state: EPageState.ValidationCode,
        status: ERequestStatus.Initial,
      };
    },
    setRequestFailure: state => {
      return {
        ...state,
        status: ERequestStatus.Failure,
      };
    },
    setRequestSubmitting: state => {
      return {
        ...state,
        status: ERequestStatus.Loading,
      };
    },
    setRequestSuccess: state => {
      return {
        ...state,
        state: EPageState.RequestSent,
        status: ERequestStatus.Success,
      };
    },
    setAnimationAvailable: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        animationAvailable: action.payload,
      };
    },
  },
});

export const {
  reducer: pageStateReducer,
  actions: {
    openRequestForm,
    setPhoneValidation,
    setRequestFailure,
    setRequestSubmitting,
    setRequestSuccess,
    setAnimationAvailable,
  },
} = pageStateSlice;
